import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFilter } from '../../hooks'
import { sendStaffAppMetaData } from '../../eventTriggers'

export const Doctors = () => {
  const [ filter, setFilter, Input ] = useFilter()
  const { therapists: doctors } = useSelector(state=>state)
  const tabDefaultMetaData = useSelector(state=>state.config.tab_default_meta_data.find(tab=> tab.detail == 'doctors'))
  const dispatch = useDispatch()

  function handleClick(resource) {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "therapist",
        resource
      }
    })
    sendStaffAppMetaData(tabDefaultMetaData.modal)
  }

  return(
    <div>
      <Input {...{filter, setFilter }}/>
      {
        doctors.filter(doctor=>((doctor.doctor_name || '').toLowerCase().includes(filter.toLowerCase()))).map(doctor=>(
          <div key={doctor.id} onClick={()=>handleClick(doctor)} className="p-4 border-bottom clickable">
            <b>{ doctor.doctor_name }</b>
          </div>
        ))
      }
    </div>
  )
}